import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NzModalService } from 'ng-zorro-antd/modal';
import { QRcode } from './QRcode';
import { eingsoft } from './eingsoft';
import jwt_decode from "jwt-decode";
import { Router } from '@angular/router';
import { EmopUtilsService } from '../../services/emop-utils.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Response } from "../../common/Response";
import { EmopSidebarPasswordComponent } from './components/emop-sidebar-password/emop-sidebar-password.component';

@Component({
  selector: 'emop-sidebar',
  templateUrl: './emop-sidebar.component.html',
  styleUrls: ['./emop-sidebar.component.scss']
})
export class EmopSidebarComponent implements OnInit {
  QRcode = QRcode;
  eingsoft = eingsoft;
  aboutModal = {
    visiable: false
  };
  changePasswordModalIsVisible: boolean = false;
  changePasswordForm: FormGroup;
  userInfo; // 用户信息
  sidebarLanguageDisplay = 'display'; // 边栏显示的语言
  /**
   * 主题
   */
  @Input() theme: 'default' | 'sub-horizontal' = 'default';
  /**
   * 主题颜色
   */
  @Input() themeColor: string = 'default';
  /**
   * 是否收缩
   */
  @Input() isCollapsed = false; // 是否收缩
  /**
   * 用户名字
   */
  @Input() userName = ''; // 用户名字
  // logo数据
  @Input() logoUrl = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAVCAYAAADGpvm7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPeSURBVHgB1VnhVdtADBY8/pdO0Nug6QR1Jmg6QdMJGiaImYAwQdIJoBM4TEA6QdwJgAmu+nJyuCiyfXYCtN97wjmfpNPp7iSdITLgvc+YZkz3TA8+HU7pcUxFpGPOdE4JiGS9yHeRtex/kPasshP6mCZMNzKWU3pyn44H0THTetom1wfa0JnBk1OasxaG7OSI9sO5cDwcDYcPYC/1d7TGNNZ1GhvJj4Ipo+PB2oFT37Li3J/x41uivkpmxI97Srd/JPrKk5OTR/n9SMdDHjv7TIx0FJzsDAEMvqRnI84rA2t4UzBnGrb0J0OcfEPd4SDH8rBlzDSj4wLOvuOFXG5a3j6mAI5+Uly00KAXmNTITBtkcoMf4WJt8OIdwsJAeDJpW7zoKwzdOnSsG+Y6qJlvERtqodOuqhm8ydFIHueG05qQJ47RuEH8rgNz0TFv4QPWCXMu9DyrjrE9p5bMmQDf7GjgSvHftPDnit9amKTj78NirNX89cL3cfTEsMkhGY4M/iXHlZJeHjAqEwPHNbY0QfOXlB5nc6bvTHF1MKYXApLhB+M94k2f0HHZskArConURe/mPNZX2p0wUMrTNejLVDt5g6DSkDk6pe/QhJip9iNsOiN7InDGmLrjJ9nVyHZQpgsKFU4FJ20dU4eKz4LeJL8oERK2VrQ7/4/UExJ2sFm+qK47/IGje1cVfYBSh4265p8/otfahs3JYD5qgZZLKi99qG+fmGBHl3DlGuK0q3mf488ZvQ1yCivvjD5cIHJKg3asaxMQJ59gDB/q752xqR2O0oENg1OzcXRpCC8pJIquSNpREh+h3woNQ0rHb6ZB1MbiLeqYxcnvefyqhteOfqLjAH6Ak7fxHo6GsU4xupeuOmpCyGXHcZe0e1UfoZSydGgn+1C+6mv+LfUHnFtSyBMzudbvGDCpqVkzOhB+v44uVD8+5hTStzDk10o+N+T118V7v18PT2NZkdO61z6hjvahdtfUnudqjN0qpQPQ5ugE+bVvcLTwzOpsl7nNlZMzppUhY+nufGGpw6ls8WujzzEVPlwk/mWgJFupdyUF+5dMn9D24eRioQvaL+O6JOBe2FQdkoE/036x7ShcKFIvL8Ptl6pXgA9VA2IiYmtVi1+ii8LXvOpIN9lfUrcE3Aun0W/czg5JBm+BjJ5vg0MhVB7I9in3AxQCw9f43LB1NEIIE5yNsquk/wMIe5ns7Csh7PAyQe6C5zt4pW86+xcWHnjBDyQx1KcZdbuW6jp6SeEYV/hD3QCnvYvaO7FYQt6Ywu79HpVUSJAZPdtf/aMCdfJth/CG8RZRO+meYOEv9UhBeJO9PWsAAAAASUVORK5CYII=';
  /**
   * 当前app名字
   */
  @Input() appName = 'ec-components';
  /**
   * 当前app图标
   */
  @Input() icon = '';
  @Input() roles = []; // 角色列表
  @Input() depts = []; // 部门列表
  @Input() languageList: {
    alias: string,
    value: string;
  }[] = [
      {
        alias: '中文',
        value: 'zh'
      },
      {
        alias: '英文',
        value: 'en'
      }
    ];
  @Input() custom: ('logout' | 'logoUrl' | 'about' | 'appName')[] = [];
  @Input() dropDownData: ('logout' | 'about' | 'language' | 'dept' | 'role' | 'changePassword')[] = [
    'logout',
    'about',
    'language',
  ];
  @Input() layout: ('left' | 'top')[] = ['left', 'top'];
  sidebarData = [];
  @Output() logout = new EventEmitter;  // 退出登录
  @Output() changeLanguage = new EventEmitter;  // 修改语言
  @Output() changeRole = new EventEmitter;  // 修改角色
  @Output() changeDept = new EventEmitter;  // 修改部门
  @Output() getUserInfo = new EventEmitter;  // 获取用户信息
  constructor(
    private http: HttpClient,
    private nzModalService: NzModalService,
    private emop: EmopUtilsService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    if (localStorage.getItem("sidebarData")) this.sidebarData = JSON.parse(localStorage.getItem("sidebarData"));
    this.getSideBarData();
    this.getUserName();
    this.getSidebarLanguageDisplay();
  }
  /**
   * 获取语言显示的值
   */
  getSidebarLanguageDisplay() {
    let cookieObj = {};
    let tempArr = document.cookie.split('; ');
    tempArr.forEach(item => {
      const keyValArr = item.split('=');
      if (keyValArr[0] === 'lang') return this.sidebarLanguageDisplay = `display_${keyValArr[1]}`;
    });
  }
  changePasswordFn() {
    this.nzModalService.create({
      nzTitle: '密码修改',
      nzContent: EmopSidebarPasswordComponent,
      nzClosable: false,
      nzFooter: null,
      nzComponentParams: {
        userInfo: this.userInfo
      }
    });
  }
  // userId: string;
  getUserName() {
    this.userInfo = jwt_decode(document.cookie);
    if (!this.userName) {
      this.userName = this.userInfo['additionalData'].additionalData.name;
    }
    this.getUserInfo.emit(this.userInfo);
  }
  /**
   * 获取侧边栏数据
   */
  getSideBarData() {
    this.http.get('/gateway/apps/activated').subscribe((rs: {
      data: any,
      status: number;
    }) => {
      if (rs?.status === 200) {
        this.sidebarData = rs.data;
        localStorage.setItem("sidebarData", JSON.stringify(this.sidebarData));
      }
    });
  }
  /**
   * 页面跳转
   * @param url 页面地址
   */
  navigate(url: string) {
    location.href = url;
  }
  /**
   * 修改语言
   */
  changeLanguageFn(value) {
    this.sidebarLanguageDisplay = 'display_' + value;
    this.changeLanguage.emit(value);
  }
  /**
   * 退出登录
   */
  logoutFn() {
    const custom = this.custom;
    this.nzModalService.create({
      nzTitle: '提示',
      nzContent: '确定退出登录?',
      nzClosable: true,
      nzOnOk: () => {
        if (custom.some(item => item === 'logout')) {
          this.logout.emit();
        } else {
          this.emop.logout();
        }
      }
    });
  }
  changeRoleFn(role: string) {
    this.changeRole.emit(role);
  }
  changeDeptFn(dept: string) {
    this.changeDept.emit(dept);
  }
  /**
   * 是否当前选中的项目
   */
  isMenuSelected(menu): boolean {
    return menu.homepage === location.pathname;
  }
}
